module.exports = __webpack_public_path__ + "static/media/mail.acd983a3.svg";